<template>
  <div>
    <v-container class="page" fluid>
    <v-row>
      <v-col no-gutters>
        <div style="margin-top: 5cm;" v-if="this.loading"> 
          <Loading/>
        </div>
        <v-container v-if="!this.loading" fluid :style="!$vuetify.breakpoint.smAndDown ? 'margin-left: 2cm; margin-top: 2cm;' : 'margin-left: auto; margin-top: 2cm;'">
          <h1 v-if="this.step == 1">Sign up for a Waste <br/> Dash account</h1>
          <h2 v-if="this.step == 2">Personal info</h2>
          <h2 v-if="this.step == 3">Payment</h2>
          <h2 v-if="this.step == 4">T's & C's</h2>
          <br/> <br/>
          <v-row justify="center">
            <v-col :md="step === 4 ? '10' : '7'">
              <div v-if="step === 1" :style="(step === 1) ? 'text-align: center;' : 'display: none;'">
                <validation-observer ref="observer-1">
                  <validation-provider
                      rules="email|required"
                      v-slot="{ errors }">
                      <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                    <v-text-field
                      filled
                      prepend-inner-icon="mdi-email"
                      autofocus
                      autocomplete="off"
                      type="email"
                      name="emailAddress"
                      id="email"
                      :class="(errors[0]) ? 'input-error' : ''"
                      placeholder="  Email Address"
                      v-model="form.emailAddress"
                    ></v-text-field>
                  </validation-provider>
                  <validation-provider
                      name="password"
                      rules="required|min:6"
                      v-slot="{ errors }">
                      <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                    <v-text-field
                      filled
                      prepend-inner-icon="mdi-lock"
                      autocomplete="off"
                      name="password"
                      id="password"
                      placeholder="  Password"
                      v-model="form.password"
                      :class="(errors[0]) ? 'input-error' : ''"
                      :type="show ? 'text' : 'password'" 
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show = !show"
                    >
                    </v-text-field> 
                  </validation-provider>
                  <validation-provider
                      rules="required|confirmedPassword:@password"
                      v-slot="{ errors }">
                      <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                    <v-text-field
                      filled
                      prepend-inner-icon="mdi-lock"
                      autocomplete="off"
                      name="confirm-password"
                      id="confirm-password"
                      placeholder="  Confirm password"
                      v-model="form.confirmPassword"
                      :class="(errors[0]) ? 'input-error' : ''"
                      :type="show ? 'text' : 'password'" 
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show = !show"
                    >
                    </v-text-field>
                  </validation-provider>
                </validation-observer>
              </div>
              <div v-if="step === 2" :style="(step === 2) ? 'text-align: center;' : 'display: none;'">
                <validation-observer ref="observer-2">
                  <v-row>
                    <v-col>
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }">
                        <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                        <v-text-field
                            filled
                            autocomplete="off"
                            type="text"
                            name="fname"
                            id="firstname"
                            v-model="form.fname"
                            placeholder="First name"
                            :class="(errors[0]) ? 'input-error' : ''"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col>
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }">
                        <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                        <v-text-field
                            filled
                            type="text"
                            name="lname"
                            id="lastname"
                            v-model="form.lname"
                            placeholder="Last name"
                            :class="(errors[0]) ? 'input-error' : ''"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <validation-provider
                      rules="required|phone"
                      v-slot="{ errors }">
                      <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                    <v-text-field
                      filled
                      prepend-inner-icon="mdi-phone"
                      autocomplete="off"
                      type="text"
                      name="mobile"
                      id="phone"
                      :class="(errors[0]) ? 'input-error' : ''"
                      placeholder="  Mobile Number eg: 0671234567"
                      v-model="form.mobile"
                    >
                    </v-text-field>
                  </validation-provider>
                  <validation-provider
                      v-slot="{ errors }">
                      <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                    <v-text-field
                        filled
                        prepend-inner-icon="mdi-office-building"
                        type="text"
                        name="company_reg_no"
                        id="companyname"
                        v-model="form.companyname"
                        placeholder="  Company name (if applicable)"
                        :class="(errors[0]) ? 'input-error' : ''"
                    ></v-text-field>
                  </validation-provider>
                  <validation-provider
                      v-slot="{ errors }"
                      rules="vatLength">
                      <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                    <v-text-field
                        filled
                        prepend-inner-icon="mdi-note-text-outline"
                        type="text"
                        name="vat_no"
                        id="vat"
                        v-model="form.vat_no"
                        placeholder="  VAT no. (if applicable)"
                        :class="(errors[0]) ? 'input-error' : ''"
                    ></v-text-field>
                  </validation-provider>
                </validation-observer>
              </div>
              <div v-if="step === 3" :style="(step === 3) ? '' : 'display: none;'">
                <v-row justify="center">
                    <v-col align="center">
                      <div style="display: block; align-self: center;">
                        <v-img 
                        v-if="card"
                        contain
                        src="@/assets/visa.png" 
                        alt="Logo"  
                        max-height="200"
                        max-width="250"
                        />
                        </div>
                    </v-col>
                  </v-row>
                  <br/><br/><br/>
                  <v-row no-gutters>
                    <v-col align="right">
                      <v-btn
                        :dark="this.eft ? true : false"
                        style="border-radius: 30px;"
                        width="100"
                        height="50"
                   
                        large
                        @click="checkEft()"
                        >EFT</v-btn>
                    </v-col>
                    <v-col align="left">
                      <v-btn
                        :dark="this.card ? true : false"
                        style="border-radius: 30px;"
                        width="100"
                        height="50"
                     
                        large
                        @click="checkCard()"
                        > Card </v-btn>
                    </v-col>
                  </v-row>
                  <br/> <br/>
                  <v-label v-if="this.eft"> You will be invoiced upon delivery of service. <br/><br/>
                    Payment instructions will be attached on the invoice. <br/><br/>
                    <span style="color: black;"> Please make sure to pay the invoice within 24 hours. </span>
                  </v-label> 
                  <br/>
                <validation-observer ref="observer-3" v-if="this.card">
                  <h3>Credit or Debit card </h3> <br/>
                  <v-label>Your card will only be charged on delivery of services.</v-label> 
                  <br/><br/>
                  <v-row justify="center">
                    <v-col align="center">
                      <stripe-element-card
                        ref="elementRef"
                        :pk="publishableKey"
                        @token="tokenCreated"
                        hidePostalCode
                      />
                    </v-col>
                  </v-row>
                </validation-observer>
                <br/> <br/>
                <span v-for="(error, idx) of errors" :key="idx" class="error-block">{{ error }}</span>
                <button v-if="this.card || this.eft" class="tc" @click="showTc = true"> Here are our terms and conditions </button>
                <v-checkbox
                v-if="this.card || this.eft"
                v-model="check"
                label="I have read and agreed to the terms and conditions"
                color="red"
                >
                </v-checkbox>
              </div>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col md="7" align="center">
              <v-btn
              v-if="this.step == 1"
              block
              style="background-color: #EF5350; color: #F5F5F5; margin-top: -0.5cm; border-radius: 30px;" 
              height="60"
              @click="signUp()"> Next Step </v-btn>

              <v-btn
              v-if="this.step == 2"
              block
              style="background-color: #EF5350; color: #F5F5F5; margin-top: -0.5cm; border-radius: 30px;" 
              height="60"
              @click="captureAdditionalInformation()"> Next Step </v-btn>

              <v-btn
              :disabled="disabled"
              v-if="this.step == 3 && check"
              block
              style="background-color: #EF5350; color: #F5F5F5; margin-top: -0.5cm; border-radius: 30px;" 
              height="60"
              @click="submit"> Sign Up </v-btn>
              <br/> <br/> <br/> <br/> <br/>
              <span v-if="this.step == 1">Already have an account? <router-link to="/login" style="color: #EF5350; text-decoration: none;"> Log in </router-link> </span> 
            </v-col>
          </v-row>    
        </v-container>
      </v-col>
      <v-col v-if="!$vuetify.breakpoint.smAndDown" no-gutters cols="6" :style="showTc ? '' : 'background-image: linear-gradient(60deg, #EF5350, red); height: 100vh;'">
        <div class="tc" v-if="showTc">
          <button style="background-color: #EF5350;" @click="showTc = !showTc"> Accept Terms and Conditions </button>
          <tc style="color: #212121;"/>
          <button style="background-color: #EF5350;"  @click="showTc = !showTc"> Accept Terms and Conditions </button>
        </div>
      </v-col>
    </v-row>
  </v-container>
  </div> 
</template>

<script>
import Loading from "@/components/Loading";
import tc from "@/views/tc"
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { email, required } from 'vee-validate/dist/rules';
import { StripeElementCard } from '@vue-stripe/vue-stripe';
const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3}?)[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
const auth = getAuth();

//remember to add custom stripe css


  extend('required', {
    ...required,
    message: 'This field is required.'
  })

  extend('email', {
    ...email,
    message: 'Invalid email'
  })

  extend('length', {
    params: [],
    validate(value) {
      if(value.length == 3)
      return true;
    },
    message: 'CVV must be three numbers'
  })

  extend('vatLength', {
    params: [],
    validate(value) {
      if(value.length == 10)
      return /^[0-9]+$/.test(value);
    },
    message: 'Vat number must be 10 digits only'
  })

  extend('numbers', {
    validate(value) {
      return /^[0-9]+$/.test(value)
    }
  })

  extend('phone', {
    params: [],
    validate(value) {
      return phoneRegex.test(value)
    },
    message: "Invalid phone number"
  })

  extend('min', {
    validate(value, { min }) {
      return value.length >= min
    },
    params: ['min'],
    message: 'Must consist of more than {min} characters'
  })

  extend('confirmedPassword', {
    params: ['target'],
    validate(value, { target }) {
      return value == target
    },
    message: 'Passwords do not match'
  })

  export default {
    name: 'SignUp',
    components: {
      Loading,
      tc,
      ValidationProvider,
      ValidationObserver,
      StripeElementCard
    },
    data() {
      return {
        step: 1,
        user: {},
        form: {
          emailAddress: '',
          mobile: '',
          password: '',
          confirmPassword: '',
          fname: '',
          lname: '',
          companyname: '',
          vat_no: ''
        },
        errors: [],
        loading: false,
        check: false,
        show: false,
        showTc: false,
        eft: false,
        card: true,
        disabled: false,
        token: null,
        publishableKey: process.env.VUE_APP_PUB_KEY
      }
    },
    methods: {   
      checkEft(){
        this.eft = true;
        this.card = false;
      },
      checkCard(){
        this.eft = false;
        this.card = true;
      },
      signUp: async function() {
        if (await this.$refs['observer-1'].validate()) {
          this.loading = true;
          createUserWithEmailAndPassword(auth, this.form.emailAddress, this.form.password)
            .then((res) => {
              this.user = res.user;
              this.step++;
              this.loading = false;
            })
            .catch((error) => {
              // Handle Errors here.
              this.loading = false;
              console.error(error);
              alert('Email already in use. Please use a different email address');
            });
        }
        else{
          alert('Please make sure to fill in details as required');
          this.loading = false;
        }
      },
      captureAdditionalInformation: async function() {
        if (await this.$refs['observer-2'].validate()) {
          this.loading = true;
          if(this.form.companyname.trim().toLowerCase() == 'private' || 
          this.form.companyname.trim().toLowerCase()  == 'prvt' || 
          this.form.companyname.trim().toLowerCase()  == 'privaat'){
            alert('Invalid company name. Please leave empty if not applicable');
            this.loading = false;
            return;
          }
          let Customer = {
              id: this.user.uid,
              mobile: this.form.mobile.trim(),
              firstName: this.form.fname.trim(),
              lastName: this.form.lname.trim(),
              companyName: this.form.companyname.trim(),
              vatNo: this.form.vat_no.trim(),
              emailAddress: this.form.emailAddress.trim(),
              scope: 'client'
            } 
            await this.$store.dispatch('auth/registerUser', Customer);
            this.step++;
            this.loading = false;
        }
        else{
          alert('Please make sure to fill in details as required');
        }
      },
      async submit() {
        this.disabled = true;
        if(this.card){
          //generate card token
          this.$refs.elementRef.submit(); 
        }
        if (this.eft){
          this.loading = true;
          await this.$store.dispatch('auth/completeRegistration', {id: this.user.uid});  
        }
      },
      async tokenCreated (token) {
        if(token){
          this.loading = true;
          await this.$store.dispatch('auth/registerUserCard', {
            id: this.user.uid,
            token: token.id,
            registration: true
          });
          this.loading = false;  
        }
      }
    },
    mounted(){
    }
  }
</script>

<style lang="scss" scoped src="@/scss/auth.scss"></style>